<template>
    <div class="item" :class="{mediaMultiple: comment.mediasUpload && comment.mediasUpload.length > 1}">
        <div class="container-text">
            <div class="author">
                <div class="author-picture">
                    <img :src="comment.avatar || 'img/avatar.jpg'"/>
                </div>
                <div class="author-tect-info">
                    <p class="name">{{ comment.name }}</p>
                    <p class="date">{{ comment.dateFormat }}</p>
                </div>
            </div>
            <p class="text" v-html="transformLinks(comment.message)"></p>
        </div>

        <VocalPlayer
            v-if="vocalFile"
            :src="vocalFile.url"
            :transcript="transcript || ''"
        />
        <div class="container-media">
            <template v-for="media in comment.mediasUpload">
                <div class="image" v-if="media.type.startsWith('image')" @click="openMedia(media.url)">
                    <img :src="media.url"/>
                </div>
                <div class="video" v-else-if="media.type.startsWith('video')" @click="openMedia(media.url)">
                    <video :src="media.url" :type="media.type" muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true"></video>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import VocalPlayer from './VocalPlayer.vue'

export default {
    components: { VocalPlayer },

    props: {
        comment: { type: Object, required: true },
    },

    data() {
        return {
            transcript: null,
        }
    },
    

    async mounted() {
       this.loadTranscript()
    },

    methods: {
        transformLinks(text) {
            if (!text) return '';
            const safeText = text
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
            const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
            return safeText.replace(urlRegex, (url) => {
                const href = url.startsWith('http') ? url : `https://${url}`;
                return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="link">${url}</a>`;
            });
        },

        openMedia(url) {
            window.open(url, '_blank');
        },

        async loadTranscript() {
            const txtFile = this.comment?.mediasUpload?.find(media => media.type === 'text/plain');
            if (!txtFile) return;

            try {
                const response = await fetch(txtFile.url);
                const text = await response.text();
                if (!this._isDestroyed) this.transcript = text;
            } catch (err) {
                console.error('[Transcript] Erreur fetch :', err);
            }
        }
    },

    computed: {
        vocalFile() {
            return this.comment?.mediasUpload?.find(media => media.type.startsWith('audio')) || null;
        }
    },
}
</script>
